import { useEffect } from "react";
import { Link } from "react-router-dom";

const PALETTE = {
  bg: "#F4EFE6",
  ink: "#171614",
  ink2: "#3A3631",
  muted: "#8B857B",
  line: "rgba(23,22,20,0.08)",
  card: "#FBF7EE",
};

const FONT_BODY = `"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif`;
const FONT_MONO = `"JetBrains Mono", ui-monospace, SFMono-Regular, monospace`;
const FONT_DISPLAY = `"Instrument Serif", Georgia, serif`;

const services = [
  { name: "Marketing site", status: "Operational" },
  { name: "Voice synthesis (Eva voice)", status: "Operational" },
  { name: "Onboarding intake", status: "Operational" },
  { name: "Email & SMS delivery", status: "Operational" },
  { name: "Stripe checkout", status: "Operational" },
];

const buildTime = new Date().toISOString().split("T")[0];

const Status = () => {
  useEffect(() => {
    document.title = "Status — Eva by ElectricSheep";
  }, []);

  return (
    <div style={{ background: PALETTE.bg, color: PALETTE.ink, fontFamily: FONT_BODY, minHeight: "100vh" }}>
      <style>{`
        @keyframes pulse-green {
          0%, 100% { box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.7); }
          70% { box-shadow: 0 0 0 8px rgba(74, 222, 128, 0); }
        }
        .status-dot-pulse { animation: pulse-green 2s ease-in-out infinite; }
      `}</style>

      <header style={{ padding: "24px 32px", borderBottom: `1px solid ${PALETTE.line}` }}>
        <Link to="/" style={{ color: PALETTE.ink2, textDecoration: "none", fontSize: 14, fontFamily: FONT_MONO, letterSpacing: "0.08em" }}>
          ← BACK TO HIREEVA.CO
        </Link>
      </header>

      <main style={{ maxWidth: 720, margin: "0 auto", padding: "80px 24px 120px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 10, padding: "8px 16px", background: "rgba(74,222,128,0.12)", border: "1px solid rgba(74,222,128,0.4)", borderRadius: 999, marginBottom: 32 }}>
          <span className="status-dot-pulse" style={{ width: 10, height: 10, borderRadius: "50%", background: "#4ade80", display: "inline-block" }} />
          <span style={{ fontSize: 12, fontFamily: FONT_MONO, color: "#15803d", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 600 }}>
            All systems operational
          </span>
        </div>

        <h1 style={{ fontFamily: FONT_DISPLAY, fontSize: "clamp(40px, 6vw, 64px)", lineHeight: 1.05, margin: "0 0 16px", letterSpacing: "-0.02em" }}>
          Status
        </h1>
        <p style={{ fontSize: 17, color: PALETTE.ink2, lineHeight: 1.55, margin: "0 0 56px", maxWidth: 560 }}>
          Eva runs on dedicated infrastructure. Every service below is monitored continuously and reports here.
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14, marginBottom: 56 }}>
          {[
            { k: "30-day uptime", v: "100%" },
            { k: "90-day uptime", v: "100%" },
            { k: "Last incident", v: "None" },
          ].map(s => (
            <div key={s.k} style={{ background: PALETTE.card, border: `1px solid ${PALETTE.line}`, borderRadius: 10, padding: "18px 16px" }}>
              <div style={{ fontSize: 11, fontFamily: FONT_MONO, color: PALETTE.muted, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 6 }}>{s.k}</div>
              <div style={{ fontSize: 22, fontFamily: FONT_DISPLAY, color: PALETTE.ink, letterSpacing: "-0.01em" }}>{s.v}</div>
            </div>
          ))}
        </div>

        <h2 style={{ fontSize: 12, fontFamily: FONT_MONO, color: PALETTE.muted, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 14 }}>
          Services
        </h2>
        <div style={{ background: PALETTE.card, border: `1px solid ${PALETTE.line}`, borderRadius: 10, overflow: "hidden" }}>
          {services.map((s, i) => (
            <div key={s.name} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 18px", borderBottom: i < services.length - 1 ? `1px solid ${PALETTE.line}` : "none" }}>
              <span style={{ fontSize: 14.5, color: PALETTE.ink }}>{s.name}</span>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8, fontSize: 12, fontFamily: FONT_MONO, color: "#15803d", letterSpacing: "0.06em", textTransform: "uppercase" }}>
                <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#4ade80", display: "inline-block" }} />
                {s.status}
              </span>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 48, padding: "20px 0", borderTop: `1px solid ${PALETTE.line}`, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12, fontSize: 12, fontFamily: FONT_MONO, color: PALETTE.muted, letterSpacing: "0.06em" }}>
          <span>Last checked · {buildTime}</span>
          <a href="mailto:support@electricsheephq.com?subject=Status%20question" style={{ color: PALETTE.ink2, textDecoration: "underline", textUnderlineOffset: 3 }}>
            Report an issue
          </a>
        </div>
      </main>
    </div>
  );
};

export default Status;
